"use client";
import DiscountShapeBoldIcon from "@/app/_components/Icons/DiscountShapeBoldIcon";
import CardCarousel from "./CardCarousel";
import { SProduct } from "@/__generated__/sdk";
import { useQuery } from "@tanstack/react-query";
import { useGqlClient } from "@/Providers/GQLProvider";

type Props = {
  catId: number
};
export default function ProductSpecialOffersSection({catId}: Props) {
  const gqlClient = useGqlClient();

  const { data, isFetching, isLoading } = useQuery({
    queryKey: [gqlClient.HomePageData.name, catId],
    queryFn: () => {
      return gqlClient.HomePageData({ categoryId: catId });
    },
    select(data) {
      if (data) {
        return data.homePageData.mostOfferProducts;
      } else [];
    },
  });
  return (
    <>
      <CardCarousel
        items={data as any}
        loading={isFetching || isLoading}
        title={"پیشنهاد <b>ویژه</b>"}
        icon={<DiscountShapeBoldIcon />}
        href="/products?sort=related&filter[hasOffer]=true"
        showMore
        surface="home_offer"
      />
    </>
  );
}
